<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7fHQ6N/tc-custom/9781609256869.jpg?1726755981709" alt="This image is the cover for the book Astrology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Astrology
      </h1>
      <p class="bookDescription body article font2">
        <b>A guide to the practice of astrology, for students, novice astrologers and therapists interested in providing counseling and readings.</b><br/><br/>Astrology ascribes meaning to planetary events and assumes that the energy that moves the universe has a kind of inherent intelligence. The astrologer maintains that there is a natural resonance between the evolving motion of the universe, and the development of the human soul. For the first time, Adrian Duncan shows how to empower clients and create transformation by harnessing horoscopes.<br/><br/>Duncan has created an innovative manual that masterfully guides astrological practitioners and interpreters through every aspect of working with clients. Going beyond astrology simply as a diagnostic tool, <i>Astrology: Transformation &amp; Empowerment</i> shows how to harness perception and sensory states to create positive change in one interpretive session.<br/><br/>Part 1 “Setting the Scene,” explains how to read the client before reading their chart. Body language, mind reading, and the elements are touched upon.<br/><br/>Part 2 “The Major Players,” depicts specific planetary combinations and what they entail in regard to emotional responses, relationships, and the future.<br/><br/>Part 3 “Transformation Methods,” teaches ways to expand awareness of the problem at hand, reframe the reading, expand sensory skills, and discover new communications systems. Throughout, Duncan shares profiles and vignettes of clients that demonstrate his techniques.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrian Ross Duncan, Erin Sullivan
      </h2>
      
      <p class="authorDescription body article">Adrian Ross Duncan has practiced astrology fulltime since 1985. He is the author of Doing Time on Planet Earth and World of Wisdom software.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?506e036a